<script lang="ts">
	export let container: HTMLDivElement | undefined = undefined;
</script>

<div
	bind:this={container}
	class="w-full md:mx-auto md:w-[90%] xl:w-3/4 2xl:w-4/5 3xl:w-[65%]
               {$$props.class || ''}"
>
	<slot />
</div>
